module.exports = __webpack_public_path__ + "img/766.b4a0fe41.png";